// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"57f48d7d","99":"2d66b82e","195":"227beb2e","326":"62c71c1c","361":"a9b9aeb6","453":"747756eb","501":"b705070f","543":"6d054330","552":"200a0639","606":"f078e835","630":"a1ade538","708":"3ad81027","740":"281dd9a5","760":"d0310535","949":"ccb6d37a"}[chunkId] + ".chunk.js";
};